function replaceWithCDN(url) {
  if (!url) return url;
  
  const cdnBase = process.env.STATICLY_MEDIA_DOMAIN ? `https://${process.env.STATICLY_MEDIA_DOMAIN}/wp-content/uploads` : '';
  
  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname;

    if (hostname.includes("staticlyproject.com") || hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
      return url;
    }

    return `${cdnBase}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return url; // not a valid URL, return as-is
  }
}

export default replaceWithCDN;